var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHourglassIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.24 2H8.76C5 2 4.71 5.38 6.74 7.22L17.26 16.78C19.29 18.62 19 22 15.24 22H8.76C5 22 4.71 18.62 6.74 16.78L17.26 7.22C19.29 5.38 19 2 15.24 2Z",
    stroke: "#9B0000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassIcon);
export default __webpack_public_path__ + "static/media/hourglass-icon.7563666c13961c6a5ee7d85329c29e47.svg";
export { ForwardRef as ReactComponent };